<template>
  <b-navbar-nav class="nav">
    <b-nav-item
      id="email"
      :to="{
        name: 'apps-email',
      }"
    >
      <!-- to="/email" -->
      <feather-icon
        icon="MailIcon"
        size="21"
        :badge="count"
        badge-classes="bg-danger"
      />
      <b-tooltip
        triggers="hover"
        target="email"
        title="پیام ها"
        :delay="{ show: 500, hide: 50 }"
      />
    </b-nav-item>
  </b-navbar-nav>
</template>

<script>
import { BNavbarNav, BNavItem, BTooltip } from "bootstrap-vue";

export default {
  computed: {
    count() {
      return this.$store.state.appConfig.count;
    },
  },
  components: {
    BNavbarNav,
    BNavItem,
    BTooltip,
  },
};
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/bootstrap-extended/include";

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
p {
  margin: 0;
}

.nav-bookmar-content-overlay {
  position: fixed;
  opacity: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-transition: all 0.7s;
  transition: all 0.7s;
  z-index: -1;

  &:not(.show) {
    pointer-events: none;
  }

  &.show {
    cursor: pointer;
    z-index: 10;
    opacity: 1;
  }
}
</style>
